import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconThumbsDown12Filled from './IconThumbsDown12Filled';
import IconThumbsDown12 from './IconThumbsDown12';
import IconThumbsDown16Filled from './IconThumbsDown16Filled';
import IconThumbsDown16 from './IconThumbsDown16';
import IconThumbsDown20Filled from './IconThumbsDown20Filled';
import IconThumbsDown20 from './IconThumbsDown20';
import IconThumbsDown24Filled from './IconThumbsDown24Filled';
import IconThumbsDown24 from './IconThumbsDown24';
import IconThumbsDown32Filled from './IconThumbsDown32Filled';
import IconThumbsDown32 from './IconThumbsDown32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconThumbsDown = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && props.filled && <IconThumbsDown12Filled {...props} />}
            {size === IconSize.Size12 && !props.filled && <IconThumbsDown12 {...props} />}
            {size === IconSize.Size16 && props.filled && <IconThumbsDown16Filled {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconThumbsDown16 {...props} />}
            {size === IconSize.Size20 && props.filled && <IconThumbsDown20Filled {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconThumbsDown20 {...props} />}
            {size === IconSize.Size24 && props.filled && <IconThumbsDown24Filled {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconThumbsDown24 {...props} />}
            {size === IconSize.Size32 && props.filled && <IconThumbsDown32Filled {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconThumbsDown32 {...props} />}
        </span>
    );
};
IconThumbsDown.displayName = 'FondueIconThumbsDown';

export default memo(IconThumbsDown);
